import * as React from 'react';

interface FRssFeedIconProps {
  style?: React.CSSProperties;
  size?: number;
  color?: string;
}

/** Figma 资源节点 580:3407 标准 RSS 扇形图标 */
function FRssFeedIcon({ style, size = 12, color = '#999999' }: FRssFeedIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
      style={style}
    >
      <path
        d='M1.875 8.25C2.91053 8.25 3.75 9.08947 3.75 10.125C3.75 11.1605 2.91053 12 1.875 12C0.839466 12 0 11.1605 0 10.125C0 9.08947 0.839466 8.25 1.875 8.25Z'
        fill={color}
      />
      <path
        d='M0 3.75C4.55635 3.75 8.25 7.44365 8.25 12H7.5C7.5 7.85786 4.14214 4.5 0 4.5V3.75Z'
        fill={color}
      />
      <path
        d='M0 0C6.62742 0 12 5.37258 12 12H11.25C11.25 5.7868 6.2132 0.75 0 0.75V0Z'
        fill={color}
      />
    </svg>
  );
}

export default FRssFeedIcon;
